import './Subiecte.css';

export default function Subiecte2025() {
    return (
        <div className="container my-4">
            <h2 className="fw-bold mb-4 subjectTitle">{'<'}Subiecte 2025{'/>'}</h2>
            <div className="mb-4">
                <h5>1. <strong>August</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2025/SubiectAugust2025MIC.pdf" target="_blank" rel="noreferrer">
                                    Subiect C/C++
                                </a>{" "}
                                |{" "}
                                <a href="/subiecte/2025/SubiectAugust2025MIPascal.pdf" target="_blank" rel="noreferrer">
                                    Subiect Pascal
                                </a>
                            </li>
                            <li>
                                <a href="/subiecte/2025/BaremAugust2025MI.pdf" target="_blank" rel="noreferrer">
                                    Barem
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2025/SubiectAugust2025SNC.pdf" target="_blank" rel="noreferrer">
                                    Subiect C/C++
                                </a>
                            </li>
                            <li>
                                <a href="/subiecte/2025/BaremAugust2025SN.pdf" target="_blank" rel="noreferrer">
                                    Barem
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div className="mb-4">
                <h5>2. <strong>Iunie</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2025/SubiectIunie2025MIC.pdf" target="_blank" rel="noreferrer">
                                    Subiect C/C++
                                </a>{" "}
                                |{" "}
                                <a href="/subiecte/2025/SubiectIunie2025MIPascal.pdf" target="_blank" rel="noreferrer">
                                    Subiect Pascal
                                </a>
                            </li>
                            <li>
                                <a href="/subiecte/2025/BaremIunie2025MI.pdf" target="_blank" rel="noreferrer">
                                    Barem
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Matematică-Informatică (Rezervă):</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2025/SubiectRezerva2025MIC.pdf" target="_blank" rel="noreferrer">
                                    Subiect C/C++
                                </a>
                            </li>
                            <li>
                                <a href="/subiecte/2025/BaremRezerva2025MI.pdf" target="_blank" rel="noreferrer">
                                    Barem
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2025/SubiectIunie2025SNC.pdf" target="_blank" rel="noreferrer">
                                    Subiect C/C++
                                </a>{" "}
                                |{" "}
                                <a href="/subiecte/2025/SubiectIunie2025SNPascal.pdf" target="_blank" rel="noreferrer">
                                    Subiect Pascal
                                </a>
                            </li>
                            <li>
                                <a href="/subiecte/2025/BaremIunie2025SN.pdf" target="_blank" rel="noreferrer">
                                    Barem
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div className="mb-4">
                <h5>3. <strong>Sesiunea Specială</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2025/SubiectSpeciala2025MIC.pdf" target="_blank" rel="noreferrer">
                                    Subiect C/C++
                                </a>
                            </li>
                            <li>
                                <a href="/subiecte/2025/BaremSpeciala2025MI.pdf" target="_blank" rel="noreferrer">
                                    Barem
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div className="mb-4">
                <h5>4. <strong>Simulare</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2025/SubiectSimulare2025MIC.pdf" target="_blank" rel="noreferrer">
                                    Subiect C/C++
                                </a>{" "}
                                |{" "}
                                <a href="/subiecte/2025/SubiectSimulare2025MIPascal.pdf" target="_blank" rel="noreferrer">
                                    Subiect Pascal
                                </a>
                            </li>
                            <li>
                                <a href="/subiecte/2025/BaremSimulare2025MI.pdf" target="_blank" rel="noreferrer">
                                    Barem
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2025/SubiectSimulare2025SNC.pdf" target="_blank" rel="noreferrer">
                                    Subiect C/C++
                                </a>{" "}
                                |{" "}
                                <a href="/subiecte/2025/SubiectSimulare2025SNPascal.pdf" target="_blank" rel="noreferrer">
                                    Subiect Pascal
                                </a>
                            </li>
                            <li>
                                <a href="/subiecte/2025/BaremSimulare2025SN.pdf" target="_blank" rel="noreferrer">
                                    Barem
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div className="mb-4">
                <h5>5. <strong>Model</strong></h5>
                <ul className="ms-3">
                    <li>
                        <strong>Specializarea Matematică-Informatică:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2025/SubiectModel2025MIC.pdf" target="_blank" rel="noreferrer">
                                    Subiect C/C++
                                </a>{" "}
                                |{" "}
                                <a href="/subiecte/2025/SubiectModel2025MIPascal.pdf" target="_blank" rel="noreferrer">
                                    Subiect Pascal
                                </a>
                            </li>
                            <li>
                                <a href="/subiecte/2025/BaremModel2025MI.pdf" target="_blank" rel="noreferrer">
                                    Barem
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li className="mt-2">
                        <strong>Specializarea Științele-Naturii:</strong>
                        <ul className="ms-3">
                            <li>
                                <a href="/subiecte/2025/SubiectModel2025SNC.pdf" target="_blank" rel="noreferrer">
                                    Subiect C/C++
                                </a>{" "}
                                |{" "}
                                <a href="/subiecte/2025/SubiectModel2025SNPascal.pdf" target="_blank" rel="noreferrer">
                                    Subiect Pascal
                                </a>
                            </li>
                            <li>
                                <a href="/subiecte/2025/BaremModel2025SN.pdf" target="_blank" rel="noreferrer">
                                    Barem
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    );
}